import "./index.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { App } from "./App";
import { MealPlan } from "./pages/MealPlanPage";
import { CreateMealPage } from "./pages/CreateMealPage";
import { UserMealsPage } from "./pages/UserMealsPage";
import { PageNotFound } from "./pages/PageNotFound";
import { DashboardPage } from "./pages/DashboardPage";
import { ShoppingListPage } from "./pages/ShoppingListPage";
import { SignIn } from "./pages/SignInPage";
import { Verification } from "./pages/VerificationPage";
import { AuthProvider } from "./contexts/AuthContext";
import { PrivateRoute } from "./routing/PrivateRoute";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import { EditMealPage } from "./pages/EditMealPage";
import { SettingsPage } from "./pages/SettingsPage";
import { ExplorePage } from "./pages/ExplorePage";
import { FridgePage } from "./pages/FridgePage";
import { RemindersPage } from "./pages/RemindersPage";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ThemeContextProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/signin" element={<SignIn />} />
            <Route path="/verification" element={<Verification />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <App />
                </PrivateRoute>
              }
            >
              {/* Nested routes within the authenticated App layout */}
              <Route index element={<DashboardPage />} />
              <Route path="CreateMeal" element={<CreateMealPage />} />
              <Route path="/recipes/edit/:id" element={<EditMealPage />} />
              <Route path="ShoppingList" element={<ShoppingListPage />} />
              <Route path="Reminders" element={<RemindersPage />} />
              <Route path="MealList" element={<UserMealsPage />} />
              <Route path="Explore" element={<ExplorePage />} />
              <Route path="Fridge" element={<FridgePage />} />
              <Route path="MealPlan" element={<MealPlan />} />
              <Route path="Dashboard" element={<DashboardPage />} />
              <Route path="Settings" element={<SettingsPage />} />
              <Route path="*" element={<PageNotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
  </ThemeContextProvider>
);
